document.addEventListener('DOMContentLoaded', function () {
  const SECTION_SELECTOR = '[data-product-tabs]';

  function tabButtons(section) {
    return Array.from(section.querySelectorAll('[data-tab-button]'));
  }

  function tabContents(section) {
    return Array.from(section.querySelectorAll('.product-tab-content'));
  }

  function contentFor(section, button) {
    const targetId = button.getAttribute('data-tab-target');
    return targetId ? section.querySelector(`[id="${targetId}"]`) : null;
  }

  // Hide tabs whose content panel rendered empty (e.g. no documents available)
  function hideEmptyTabs(section) {
    tabButtons(section).forEach((button) => {
      const content = contentFor(section, button);
      if (content && content.innerHTML.trim() === '') {
        button.style.display = 'none';
        content.style.display = 'none';
      }
    });
  }

  function visibleTabButtons(section) {
    return tabButtons(section).filter((button) => button.style.display !== 'none');
  }

  function activateTab(section, button) {
    tabButtons(section).forEach((btn) => {
      btn.classList.remove('active');
      btn.setAttribute('aria-selected', 'false');
    });
    tabContents(section).forEach((content) => content.classList.remove('active'));

    if (!button) return;

    button.classList.add('active');
    button.setAttribute('aria-selected', 'true');
    contentFor(section, button)?.classList.add('active');
  }

  function initSection(section) {
    hideEmptyTabs(section);
    activateTab(section, visibleTabButtons(section)[0]);
  }

  // Delegated so tabs keep working after a variant change replaces the markup.
  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-tab-button]');
    if (!button) return;

    const section = button.closest(SECTION_SELECTOR);
    if (!section) return;

    activateTab(section, button);
  });

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  /*
   * Re-render the section for the newly selected variant.
   *
   * The tabs sit outside product-info, so the variant fetch it already performs doesn't cover
   * them: without this, a dealer switching option sees the price and SKU update while the
   * Technical data tab still shows the previous variant's finish and manufacturer SKU until
   * the page is reloaded. Asking Liquid for the section keeps one source of truth — the tab
   * appears, disappears and fills exactly as it would on a fresh load.
   */
  function refreshSection(section, variantId) {
    const productUrl = section.dataset.productUrl;
    const sectionId = section.dataset.sectionId;
    if (!productUrl || !sectionId) return;

    // Rapid option clicking can resolve out of order; keep only the latest response.
    section.tabsAbortController?.abort();
    const abortController = new AbortController();
    section.tabsAbortController = abortController;

    const requestUrl = `${productUrl}?variant=${encodeURIComponent(
      variantId
    )}&section_id=${encodeURIComponent(sectionId)}`;

    fetch(requestUrl, { signal: abortController.signal })
      .then((response) => (response.ok ? response.text() : Promise.reject(response.status)))
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const updatedSection = html.querySelector(SECTION_SELECTOR);
        if (!updatedSection) return;

        const activeTarget = section
          .querySelector('[data-tab-button].active')
          ?.getAttribute('data-tab-target');

        section.innerHTML = updatedSection.innerHTML;
        // Carries the hidden class, so the block also disappears when no tab has content left.
        section.className = updatedSection.className;
        initSection(section);

        // Keep the shopper on the tab they were reading, when it still has content.
        if (!activeTarget) return;
        const previouslyActive = section.querySelector(
          `[data-tab-button][data-tab-target="${activeTarget}"]`
        );
        if (previouslyActive && previouslyActive.style.display !== 'none') {
          activateTab(section, previouslyActive);
        }
      })
      .catch((error) => {
        if (error?.name === 'AbortError') return;
        console.error('Failed to refresh product tabs', error);
      })
      .finally(() => {
        if (section.tabsAbortController === abortController) section.tabsAbortController = null;
      });
  }

  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    const variant = event?.data?.variant;
    if (!variant) return;

    document.querySelectorAll(SECTION_SELECTOR).forEach((section) => {
      refreshSection(section, variant.id);
    });
  });
});
